import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="grv-chart"
export default class extends Controller {
	static targets = ["chartdata", "chartloading"]

	connect() {
		this.setChartData()
		chartGrv.init()
	}

	chartdataTargetConnected() {
		// Wenn ein neues Target Div mit den Chartdaten das alte ersetzt (durch Stream oder replace)
		// muss das Chart aktualisiert werden
		this.setChartData()
		chartGrv.update()
	}

	chartloadingTargetConnected() {
		// console.log("ChartloadingTargetConnected")
		chartGrv.showLoading()
	}

	chartloadingTargetDisconnected() {
		// console.log("ChartloadingTargetDisconnected")
		chartGrv.hideLoading()
	}

	setChartData() {
		chartGrv.data = JSON.parse(this.chartdataTarget.dataset.chartdata)
	}
}
